import { useContext, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import "./index.less"
import { CommonTabbarContext, SystemContext } from "@/App";
import SidePanel from "@/layout/main/side-panel-group";
import DrawTool from "./draw-tool";
import TabRoutes from "@/routes/tab-routes";
import SystemManageArea from "@/global/components/system-area";
import CommonTabbar, { CommonTabbarState } from "@/global/components/common-tabbar";
import MenuPanel from "./menu";
import localStore, { LOCAL_USER_TYPE, PROJECT_LIST } from "@/global/store/local-store";
import TnMessage from "@/global/components/message";
import { SystemStatus } from "@/global/store/system-store";
import CryptoJS from 'crypto-js';
import { USER_TYPE } from '@/enums/user';

export const DRAW_MAIN_KEY = "draw-main"

export default function ProjectMain() {
    const { projectId } = useParams()
    const navigate = useNavigate();
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tab上下文
    const systemContext = useContext<SystemStatus>(SystemContext);

    useEffect(() => {
        // 验证，无项目跳转到项目列表
        if (!projectId) {
            navigate(`/project/project-list`);
        }
        if (localStore.get(LOCAL_USER_TYPE) === CryptoJS.MD5(USER_TYPE.ADMIN.toString()).toString()) {
            return;
        }
        if (!localStore.get(PROJECT_LIST)?.some(item => item === +projectId)) {
            // 该用户不在该项目中，弹出到项目列表
            TnMessage.destory();
            TnMessage.error("您无权进入该项目");
            navigate("/desktop/project-list")
        }
        commonTabbarContext.clearClosableRoute();
    }, [projectId])

    return (

        <div className="project">
            <div className="system-manager">
                <SystemManageArea />
            </div>
            <div className="menu">
                <MenuPanel />
            </div>
            <div className="project-main">
                <div className="side">
                    <SidePanel />
                </div>
                <div className="draw">
                    <div className="tool">
                        <DrawTool />
                    </div>
                    <div className="draw-main">
                        <CommonTabbar context={CommonTabbarContext} />
                        <div className="draw-body">
                            <TabRoutes />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}